import { ModalBlock } from '@/components/ModalWindow/styles';
import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';
import styled from 'styled-components';

export const ModalContent = styled(ModalBlock)`
  padding: 0;
  max-width: 800px;

  ${media.mobile`
    width: 100%;
    padding: 0;
  `}
`;

export const Body = styled.div`
  ${flex({ flexDirection: 'column' })};
  max-height: 80vh;
`;

export const Header = styled.div`
  padding: 26px 26px 22px 42px;
  border-bottom: 1px solid ${COLORS.grey[300]};

  ${media.mobile`
    padding: 20px;
  `}
`;

export const Content = styled.div`
  ${flex({ flexDirection: 'column' })};
  overflow: auto;
  padding: 28px 42px;
  row-gap: 26px;

  ${media.mobile`
    padding: 20px;
  `}
`;

export const Footer = styled.div`
  ${flex({ justifyContent: 'flex-end' })};
  border-top: 1px solid ${COLORS.grey[300]};
  padding: 22px 26px 26px 42px;

  ${media.mobile`
    padding: 20px;
  `}
`;
